import React from 'react';
import './Modal.scss';
import { Dialog } from '@mui/material';
import { outerAspectRef } from '../../Wrappers';
type Props={
    className?: string;
    id?: string;
    showModal: boolean;
    onBackdropClick?: React.MouseEventHandler<HTMLElement>
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    modalPaperStyle?: object;
    style?: React.CSSProperties;
}
const Modal: React.FC<Props> = ({ children, className = '', id, onClick, showModal, onBackdropClick, modalPaperStyle, style }) => {

    return <Dialog
        data-testid={'bv-modal'}
        open={showModal}
        id={id}
        style={style}
        BackdropProps={{ style:{ position: 'absolute', height: '100%', width: '100%' }, onClick: onBackdropClick }}
        container={outerAspectRef.current}
        onClick={(e): void => {
            e.stopPropagation();
            e.preventDefault();
        }}
        onClose={onBackdropClick}
        className={`bv-modal ${className}`}
        PaperProps={{ elevation:0, className:'modal-container', style: modalPaperStyle }}
    >
        {children}
    </Dialog>;
};

export default Modal;